module.exports = __webpack_public_path__ + "media/images/admin/icons/sun-ed23b430cb9f4147d84c4c1379c6cc97.svg";